
        <div class="alert" [ngClass]="'msg-'+type" role="alert">
            <ng-content></ng-content>
        </div>